export default __webpack_public_path__ + "static/media/album_large.2c3cdc02.png";